import {createArray} from "@Common/utils/collections";
import {chain}       from "@Common/utils/fs";
import {arrMapToO}   from "@Common/utils/objects";
import {waitTimeout} from "@Common/utils/wait-timeout";

import {mockDedupeData} from "./mock-dedupe-data";

const createMockState = (value) => ({
    get: () => value,
    set: (v2) => value = v2,
});
const mailingListsState = createMockState(require("./sample-data/mailing-lists"));

export const MockMailingApis = ({}) => ({
    getMailingLists: async () => {
        await waitTimeout(100);
        console.log("API getMailingLists");
        return mailingListsState.get();
    },

    createMailingList: async ({address, count}) => {
        console.log("createMailingList");

        // if (address === "235 W Garfield Ave") {
        //     return {};
        // }

        await waitTimeout(200);
        // if (address==="1") {
        const id = ""+Date.now();
        const mailingList1 = {
            "count": count,
            id,
            mailingListName: address,
            "type": "radius",
            "requirePurchase": true,
            dateCreated: new Date().toString(),
        };
        mailingListsState.set([
            mailingList1,
            ...mailingListsState.get()||[],
        ]);
        return {mailingListId: id};
    },
    createUploadMailingList: async ({data, countryCode, info}) => {
        console.log("createUploadMailingList");
        return {idList: 123};
    },
    updateMailingList: async ({id, count}) => {
        // console.log(id, limit);
        // mailingListsState.set(replaceFind(mailingListsState.get(), {id, ...content}, (i) => i.id === id));
        mailingListsState.set(mailingListsState.get().map((ml) => ml.id != id ? ml : {
            ...ml,
            count,
        }));
    },
    deleteMailingList: async () => {
        await waitTimeout(1000);
    },
    searchRadius: async (params) => {
        await waitTimeout(100);
        return require("../../../ui-components/heavy/mailing-ui/create-mailing-list-modal/types/radius/step-1-search/streets-section/streets-box/sample-radius-search-response");
        // return require("./sample-data/sample-radius-search-error-response");
    },
    searchRadiusStreetAddresses: async ({streetAddresses}) => {
        await waitTimeout(300);
        const list = chain(
            require("./sample-data/sample-radius-search-street-addresses-response"),
            (_) => Object["values"](_)[1],
        );
        return arrMapToO(
            streetAddresses,
            (r) => list.map((r2, i) => ({...r2, address: r.streetAddress + " - " + "ADDR " + (i+1)})),
            (r) => r.streetAddress
        );
    },
    createRadiusMailingList: async (req) => {
        console.log("createRadiusMailingList", req);
        return {mailingListId: 0};
    },
    getMailingListDetails: async (id) => {
        return require("./sample-data/sample-get-mailing-list-details-response");
    },
    addMailingAddress: async (address, idList) => {
        // URL : mailing/add_mailing_list_address/
        // Request :
        // {"idList":"7249954","name":"DAN MCKENZIE 234723","name2":"THE MCKENZIE LAW FIRM, LLC","address":"123 FOREST PARK BLVD","address2":"","city":"FORT WORTH","state":"TX","zipcode":"76110"}
        // Response :
        // {  "result": "success",  "addressId": 1629460875,  "message": "Address successfully created."}

        // Normal:
        // return {
        //     "result": "success",
        //     "addressId": Date.now(),
        //     "message": "Address successfully created.",
        //     status: "PASSED",
        // };

        await waitTimeout(300);
        throw "Failed to save address";

        // return {
        //     result: "failure",
        //     errors: {
        //         msg: "Failed to save address",
        //     },
        // };
    },
    updateMailingAddress: async (oldAddress, edited) => {
        // Update address in the list :
        // URL :mailing/update_mailing_list_address/
        // Request :
        // {"addressId":"1629460875","idList":"7249954","name":"DAN MCKENZIE","name2":"THE MCKENZIE LAW FIRM, LLC","address":"123 FOREST PARK BLVD","address2":"","city":"FORTWORTH","state":"TX","zipcode":"76110"}
        // Response :
        // {  "result": "success",  "addressId": 1629460875,  "message": "Address successfully updated."}

        await waitTimeout(300);
        throw "Failed to save address";

        // return {
        //     status: "PASSED",
        // };
    },
    deleteMailingAddress: async (address) => {
        // Delete an address from the list :
        // URL : mailing/delete_mailing_list_address/1629460875
        // Response :{  "result": "success",  "message": "Address deleted successfully."}
    },
    getCass: async (mailingListId) => {
        await waitTimeout(1200);
        console.log("getCass", mailingListId);
        // Request: {"id":"123","forceCass":"1", "doNotWait": "1"}
        // Response: {"status": "inProgress", "goodCount": 12, "badCount": 10, "unCassedCount": 10}
        // Response: {"status": "complete", "goodCount": 12, "badCount": 10}

        return {"status": "complete", "goodCount": 12, "badCount": 10};
        // return {"status": "inProgress", "goodCount": 12, "badCount": 10, "unCassedCount": 10};
        // return {"status": "blah", "goodCount": 12, "badCount": 10};

        // return {
        //   "statusCode": "CreateMailingList-GA01",
        //   "message": "Invalid User Access",
        //   "internalMessage": "\"Invalid User Access\""
        // };
    },

    getFailedNcoaCount: async (mailingListIds) => {
        console.log("getFailedNcoaCount");
        await waitTimeout(500);
        return arrMapToO(mailingListIds, () => 10);
    },

    searchStreet: async (form) => {
        await waitTimeout(50);
        // Request
        // POST /mailing/search_street/
        // {"streets":[{"address":"1342 N CHURCH CT","zip":"45305","MFI":"1"},{"address":"N NEVA AVE","zip":"60634","MFI":"3"}]}

        // Normal response
        // return {
        //     // "1342 N CHURCH CT": {
        //     //     "result": "success",
        //     //     "count": 1,
        //     //     "min": "1342",
        //     //     "max": "1342",
        //     //     "address": "1342 N CHURCH CT",
        //     //     "city": "BELLBROOK",
        //     //     "zip_code": "45305",
        //     //     "MFI": 1,
        //     //     "addresses": [{"address": "1342 N Church Ct", "display_address": 1, "doNotMail": 0, "sort_house": 1342}]
        //     // },
        //     "N NEVA AVE": {
        //         "result": "success",
        //         "count": 6,
        //         "min": "2911",
        //         "max": "3150",
        //         "address": "N NEVA AVE",
        //         "city": "CHICAGO",
        //         "zip_code": "60634",
        //         "MFI": 3,
        //         "addresses": [{
        //             "address": "2911 N NEVA AVE # 2",
        //             "display_address": 1,
        //             "doNotMail": 0,
        //             "sort_house": "2911"
        //         }, {
        //             "address": "3150 N NEVA AVE APT 2A",
        //             "display_address": "1",
        //             "doNotMail": 0,
        //             "sort_house": "3150"
        //         }, {
        //             "address": "3150 N NEVA AVE APT 1C",
        //             "display_address": "1",
        //             "doNotMail": 0,
        //             "sort_house": "3150"
        //         }, {
        //             "address": "3150 N NEVA AVE APT 3A",
        //             "display_address": "1",
        //             "doNotMail": 0,
        //             "sort_house": "3150"
        //         }, {
        //             "address": "3150 N NEVA AVE APT 3B",
        //             "display_address": "1",
        //             "doNotMail": 0,
        //             "sort_house": "3150"
        //         }, {"address": "3150 N NEVA AVE APT 1B", "display_address": "1", "doNotMail": 0, "sort_house": "3150"}]
        //     }
        // };
        // Response with alternate streets:
        return {
            "1342 N CHURCH CT": {
                "result": "success",
                "count": 1,
                "min": "1342",
                "max": "1342",
                "address": "1342 N CHURCH CT",
                "city": "BELLBROOK",
                "zip_code": "45305",
                "MFI": 1,
                "addresses": [{"address": "1342 N Church Ct", "display_address": 1, "doNotMail": 0, "sort_house": 1342}]
            },
            // "ACER CT E": {
            //     "result": "NotFound",
            //     "message": "Could not find: <ACER CT E>, <76117> other possible streets addresses",
            //     "zip": "76117",
            //     "alternateStreetAddresses": [
            //         {"streetAddress": "JACK ATKINS CT"},
            //         {"streetAddress": "MACK RD"},
            //         {"streetAddress": "PLACID DR"},
            //         {"streetAddress": "TRACY DR"},
            //     ]
            // }
        }

        // return {
        //     "1110 Forest Park Bvld": {
        //         "result": "alternateStreet",
        //         "errors": {
        //             "target": "findAlternateStreets",
        //             "msg": "Could not find: 1110 FOREST PARK BVLD, 76110 other possible streets addresses"
        //         },
        //         "zip": "76110",
        //         "alternateStreets": ["FOREST PARK BLVD", "FOREST PARK BLVD APT B", "FOREST PARK BLVD APT A"]
        //     }
        // };
    },


    createStreetList: async ({streets, info}) => {
        // request:
        // {
        //     "addresses": {
        //         "1342 N CHURCH CT": {
        //             "count": 1,
        //             "min": "1342",
        //             "max": "1342",
        //             "address": "1342 N CHURCH CT",
        //             "city": "BELLBROOK",
        //             "zip_code": "45305",
        //             "MFI": 1,
        //             "addresses": [{
        //                 "address": "1342 N Church Ct",
        //                 "display_address": "1",
        //                 "doNotMail": 0,
        //                 "sort_house": 1342
        //             }]
        //         },
        //     },
        //     "listingType": "street",
        //     "alternateName": {"type": "owner|custom|or_resident|or_occupant|or_homeowner", "value": "custom name"},
        //     "listName": "list name"
        // }

        // return { "result": "<success or failure", "idList":"<list id>"};

        return { "result": "success", "idList":"123"};
    },
    updateAlternateName: async ({idList, alternateName}) => {
        await waitTimeout(1000);
        console.log("updateAlternateName", {idList, alternateName});
    },

    demographics: {
        getTargets: async () => {
            // await waitTimeout(1000);
            return require("./demographics/sample-getTargets-response");
        },
        getCustomizedInputsConfig: async (idSearch) => {
            await waitTimeout(1000);
            return require("../../../ui-components/heavy/mailing-ui/create-mailing-list-modal/types/demographics/sample-customized-2");
        },

        search: async ({idSearch, selectedTargets, searchType, geography}) => {
            console.log("search demographics", {idSearch, selectedTargets, searchType, geography});
            await waitTimeout(100);
            return require("./demographics/sample-demographicResults-response");
            // return {total: 0};
            // return {"result":"failure","errors":{"target":"demographicResults","msg":"One or more of your zip codes are not complete or have an error. Please correct and try again."}};
        },

        createMailingList: async ({idSearch,finalize,inputsCustomization, narrowing}) => {

            await waitTimeout(500);
            return {idList:23};
        },
    },

    eddm: {
        searchEddmList: async (search) => {
            // throw 123123;
            console.log("search", search);
            await waitTimeout(50);
            return {
                allRoutes: require("./eddm/sample-eddm-search"),
                searchRequestServerKey: "ABC",
            };
        },
        createMailingList: ({listName, routes}) => {
            const req = {

            };
        },
    },

    crm: {
        getCrmList: async () => ({
            "result": "success",
            "crmType": "Moxi Works",
            "crmList": [
                {
                    "id": "ezdjNGY4YjJlLTU1MTItNGQ0My1hZWU5LWQ4ZGZjOTAzNDIxZn0=__MWID__",
                    "name": "Christmas Card",
                    // "quantity": "41",
                    // "dateCreated": "2016-08-31"
                },
                {
                    "id": "ezlhZjhiNWEyLTM2YzYtNGNiOC1iOGI0LWFiMDJjYjc4YzE4YX0=__MWID__",
                    "name": "Circle of Friends"
                },
                {
                    "id": "ezgzZWY3YzExLWQwMDctNDljYi1iNjU4LTJhNjYyMTNmMDMyZX0=__MWID__",
                    "name": "Thrive Digital"
                },
                {
                    "id": "e2E0NjYxNjZlLTkzYzctNDY1ZS05NGRiLWNmMDc0MzA2MmZiOH0=__MWID__",
                    "name": "Thrive Mailer",
                }
            ]
        }),

        getCrmListAddress: async (crmList) => ({
            result: "success",
            crmList: chain(
                [
                    {
                        "idList": "7207652",
                        "name": "Industry"
                    },
                    {
                        // "idList": "7207624",
                        "name": "Community",
                        error: "AAA",
                    },
                ],
                (_) => createArray(1).map((i) => _.map((r) => ({...r, idList: r.idList + i}))).flat(),
            ),
        }),
    },

    decondo: {

        // /next-api/mailing/get_street_names/
        // {
        //   "E|100th Street": "E 100th Street",
        //   "W|100th Street": "W 100th Street",
        // }
        getStreetNames: async () => {
            // await waitTimeout(1000);
            return ({
                "E|100th Street": "E 100th Street",
                "W|100th Street": "W 100th Street",
            });
        },

        getBuildings: async () => {
            // await waitTimeout(1000);
            return ({
                "10|W|102nd Street|10025": "10 W 102nd Street, 10025",
                "102|W|102nd Street|10025": "102 W 102nd Street, 10025",
                "11|W|102nd Street|10025": "11 W 102nd Street, 10025",
            });

            // return {"result":"failure","errors":{"target":"get_buildings_on_street","msg":"No file extension present"}};
        },

        retrieveAddresses: async () => ({
            "street": {
                "name": "W 102nd Street",
                "key": "W|102nd Street",
                "begin": "200",
                "end": "200"
            },
            "addressList": [
                {
                    "name": " Current Resident",
                    "name2": "",
                    "address": "200 W 102nd Street",
                    "address2": "",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10025",
                    "street": "102nd Street"
                },
                {
                    "name": " Current Resident",
                    "name2": "",
                    "address": "200 W 102nd Street",
                    "address2": "APT 4W",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10025",
                    "street": "102nd Street"
                }
            ]
        }),


        createMailingList: ({listName, buildings}) => {
            console.log({listName, buildings});
            return {
            };

        },
    },

    dnm: {
        addDoNotMailAddress: async () => {
            await waitTimeout(500);
            return {result: "success", idPrimary: 1243324};
        },
    },

    dedupe: {
        getDuplicates: async (mlIds) => {
            console.log("dedupe.getDuplicates", mlIds);
            await waitTimeout(300);
            return mockDedupeData();
        },
    },
});
